export function Card({ children, className = '', padding = 'md', style }) {
  const paddingMap = { none: '0', sm: '16px', md: '24px', lg: '32px' };
  return (
    <div
      className={`card ${className}`}
      style={{ padding: paddingMap[padding] ?? paddingMap.md, ...style }}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, actions, bordered = false, style }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap',
      ...(bordered
        ? { padding: '14px 20px', borderBottom: '1px solid var(--border)' }
        : { marginBottom: '20px' }),
      ...style,
    }}>
      <div>
        {title && <div className="card-title">{title}</div>}
        {subtitle && <div className="card-sub" style={{ marginBottom: 0 }}>{subtitle}</div>}
      </div>
      {actions && <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>{actions}</div>}
    </div>
  );
}
